import styled from "@emotion/styled";

const Wrapper = styled("div")`
  background: white;
  border-radius: 1rem;
  overflow: hidden;
  padding: 4rem;
  ${props => props.theme.bp.below.lg} {
    padding: 2rem
  }
  &.green {
    background: ${props => props.theme.colors.primary};
    color: white;
  }

  &.image-card {
    padding: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }


  .text-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
  }

  h1 {
    font-size: 1.875rem;
    margin-bottom: .5rem;
  }
  p {
    line-height: 1.5;
  }
`;

const Card = ({ children, className }) => {
  return (
    <Wrapper className={`card ${className}`}>
      {children}
    </Wrapper>
  )
}

export default Card;